import { ListViewMode } from './ListViewModeSwitcher';
import { CONFIG } from '../../../config/mainConfig';
import React from 'react';
import { useStorageObjectUrl } from '../../../services/file.service';
import { UserModel } from '../../../interfaces/user.interface';

type StoryPagesImageProps = {
  mode: ListViewMode;
  imageURL?: string;
  pageIndex?: number;
  index?: number;
  page?: any;
  isUpdateImage?: boolean;
  updateImgIndex?: number;
  user: UserModel | null | undefined;
  hasError?: boolean;
};

export const StoryPagesImage: React.FC<StoryPagesImageProps> = ({
  mode,
  imageURL,
  pageIndex = 0,
  index = 0,
  page,
  isUpdateImage,
  updateImgIndex = -1,
  user,
  hasError = false,
}) => {
  const { url } = useStorageObjectUrl(imageURL);

  const bg = url || imageURL || '/pattern.png';
  const noImage = !page.imageURLwebp && !page.imageURL;

  return (
    <div
      className={` ${
        mode === ListViewMode.PAGE ? ` h-[350px] w-[350px]  md:w-[600px] md:h-[600px]` : ' w-72 h-72'
      } rounded-lg mx-auto bg-gray-200 flex flex-col items-center justify-between relative ${page.block ? 'block-image' : ''}`}
      style={{
        backgroundImage: `url('${bg}')`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {noImage && hasError && (
        <div className={`flex flex-col items-center justify-center gap-2 text-gray-400 ${mode === ListViewMode.PAGE ? 'mt-[14rem]' : 'mt-[5rem]'}`}>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
          <span className="text-xs font-medium">Image unavailable</span>
        </div>
      )}
      {noImage && !hasError && (isUpdateImage ? updateImgIndex == pageIndex : true) &&
        user?.plan?.name !== CONFIG.PROMO_PLAN && (
          <img
            src="/loading.gif"
            className={`h-36 w-36  ${mode === ListViewMode.PAGE ? ' mt-[14rem] ' : 'mt-[5rem]'}`}
            alt="Loading"
          />
        )}

      <div className="page-number mb-2 w-full flex justify-center absolute bottom-0 left-1/2 transform -translate-x-1/2">
        <div
          className=" w-12 h-6 flex justify-center items-center rounded-full font-bold text-base text-white"
          style={{
            fontFamily: 'system-ui',
            position: 'absolute',
            bottom: '0',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          {index * 2 + 6}
        </div>
      </div>
    </div>
  );
};
